<template>
    <div>
        <vForm :label-width="160" ref="vendors" class="margin-15 clearfix">
            <vCol span="12">
                <vFormItem label="Country" >
                    <div>{{vendorsData.countryCode}}</div>
                </vFormItem>
                <vFormItem label="Dropship" >
                    <vCheckbox v-model="vendorsData.dropship" :disabled="vendorsData.disdropship"></vCheckbox>
                </vFormItem>
                <div >
                    <vFormItem label="SellingPartyId" :rules="required" prop="sellingPartyId" style="position:relative">
                        <Tooltip  max-width="500" style="width:100%" :content="this.$t('erp.channelbase.SellingPartyId', { defaultValue: '是否渠道支付运费' })" placement="top"> <Icon class="font-14" style="position: absolute;z-index: 11;right: 5px;top: 10px;" type="md-help-circle" /> 
                        <vInput v-model="vendorsData.sellingPartyId" :disabled="vendorsData.disdropship"></vInput>
                        </Tooltip>
                    </vFormItem>
                    <vFormItem label="IsLabeled" :rules="required" prop="paymentType">
                        <Tooltip  max-width="300" class="margin-right-10" :content="this.$t('erp.channelbase.IsLabeled', { defaultValue: '是否渠道支付运费' })" placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>
                        <span v-if="vendorsData.disdropship">{{vendorsData.IsLabeled == 'N' ? $t("erp.global.no", { defaultValue: "否" }) : $t("erp.global.yes", { defaultValue: "是" })}}</span>
                        <span v-else>
                            <vRadio trueValue="N" :strict="false" v-model="vendorsData.IsLabeled" class="margin-right-10" >{{$t("erp.global.no", { defaultValue: "否" })}}</vRadio>
                            <vRadio trueValue="Y" :strict="false" v-model="vendorsData.IsLabeled" >{{$t("erp.global.yes", { defaultValue: "是" })}}</vRadio>
                        </span>
                    </vFormItem>
                    <vFormItem :label="$t('erp.channelbase.start_data_type', { defaultValue: '开启同步的数据类型' })" >
                        <vCheckbox :disabled="vendorsData.disdropship" v-for="(item,index) in vendorsList" :trueValue="item.value" :key="index" v-model="vendorsData.new_flag1" >{{item.label}}</vCheckbox>
                    </vFormItem>
                </div>
            </vCol>
            <vCol span="24">
                <div  style="height:1px;border-bottom:1px solid #ddd"></div>
            </vCol>
            <vCol span="12">
                <vFormItem label="PO" >
                    <vCheckbox :disabled="vendorsData.dispo" v-model="vendorsData.po"></vCheckbox>
                </vFormItem>
                <vFormItem :label="$t('erp.channelbase.start_data_type', { defaultValue: '开启同步的数据类型' })" >
                    <vCheckbox :disabled="vendorsData.dispo" v-for="(item,index) in vendorspoList" :trueValue="item.value" :key="index" v-model="vendorsData.new_flag2" >{{item.label}}</vCheckbox>
                </vFormItem>
            </vCol>
        </vForm>
    </div>
</template>

<script>
export default {
    props:['vendorsDetailData'],
    data(){
        return {
            vendorsData:{
                countryCode:'--',
                IsLabeled:'N',
                new_flag1:[],
                new_flag2:[],
            },
            vendorsList:[
                {
                    value: 'order',
                    label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                }, {
                    value: 'stock',
                    label: this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })
                },{
                    value: 'outbound',
                    label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                }
            ],
            vendorspoList:[
                {
                    value: 'order',
                    label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                },
            ],
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
            }],
        }
    },
    watch:{
        vendorsDetailData:{
            immediate:true,
            deep:true,
            handler(val){
                if(!val.countryCode) return;
                this.vendorsData = {
                    countryCode:'--',
                    IsLabeled:'N',
                    new_flag1:[],
                    new_flag2:[],
                };
                // console.log(val,'123141321')
                // this.vendorsData.countryCode = val.countryCode;
                this.$set(this.vendorsData,'countryCode',val.countryCode)
                if(val.type=="amazonvendords"){
                    this.$set(this.vendorsData,'sellingPartyId',val.connectStr.sellingPartyId)
                    this.vendorsData.disdropship = true
                    this.vendorsData.dropship = true
                    for(let key in val.connectStr.new_flag){
                        if(val.connectStr.new_flag[key] == 'Y'){
                            this.vendorsData.new_flag1.push(key)
                        }
                    }
                }
                if(val.type=="amazonvendor"){
                    this.vendorsData.dispo = true
                    this.vendorsData.po = true
                    for(let key in val.connectStr.new_flag){
                        if(val.connectStr.new_flag[key] == 'Y'){
                            this.vendorsData.new_flag2.push(key)
                        }
                    }
                }
                console.log(this.vendorsData)
            }
        }
    },
    methods:{
        async validate(){
            let bool2 = true;
                if(!this.vendorsData.countryCode){
                    bool2 = false
                    this.$VMessage.warning(this.$t('global.form.require', { defaultValue: "请填写必填项" }));
                    return bool2;
                }
                if(!this.vendorsData.dropship && !this.vendorsData.po){
                    bool2 = false
                    this.$VMessage.warning(this.$t('erp.managechannel.dropshipop', { defaultValue: "Dropship或者PO请勾选其一" }));
                    return bool2;
                }
                if(this.vendorsData.dropship){
                    if(!this.vendorsData.sellingPartyId){
                        bool2 = false
                        this.$VMessage.warning(this.$t('global.form.require', { defaultValue: "请填写必填项" }));
                        return bool2;
                    }
                }
                return bool2;
        }
    }
}
</script>
